import axios from "axios";

export default {
  async report() {
    try {
      const response = await axios.get("/qa/report");
      return { data: response.data };
    } catch (e) {
      return { data: null };
    }
  },
};
